import React from 'react';
import { Trophy } from 'lucide-react';
export function Header() {
  return <header className="bg-ez-dark text-white py-4 px-6 shadow-lg flex items-center justify-between sticky top-0 z-20" data-id="element-4">
      <div className="flex items-center" data-id="element-5">
        <img src="https://cdn.magicpatterns.com/uploads/pGa7Bb5XoZQRdUrrKteDtD/2025-10-31_EZLoans_LogoAssets-HorizontalWhite_resized.png" alt="EZ Loans" className="h-7 sm:h-8 object-contain" data-id="element-6" />
      </div>
      <div className="flex items-center gap-2.5" data-id="element-7">
        <Trophy className="text-ez-green w-5 h-5 sm:w-6 sm:h-6" data-id="element-8" />
        <h1 className="text-sm sm:text-lg font-bold tracking-wide uppercase" data-id="element-9">
          <span className="hidden sm:inline" data-id="element-10">Performance </span>Leaderboard
        </h1>
      </div>
    </header>;
}